import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.upload-raw';
import * as api from '../../../clients/api';

@Injectable()
export class ApiUploadRawEffects {

    UploadRaw$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_UPLOAD_RAW),
        mergeMap((x: ac.PostUploadRawAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postUploadRaw(x.uploadRequest).pipe(
                map((result: any) => {
                    return new ac.PostUploadRawErfolgreichAction(result, x.uploadRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostUploadRawFehlerAction(error, x.uploadRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.UploadService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.UploadService {
        if (this.service === null) {
            this.service = this.injector.get(api.UploadService);
        }
        return this.service;
    }
}
